import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function GeoBlocker({ children }: { children: React.ReactNode }) {
  const [isChecking, setIsChecking] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [country, setCountry] = useState<string>('');

  useEffect(() => {
    // Only run in browser
    setIsChecking(true);
    
    const checkGeoAccess = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('check-geo-access', {
          method: 'GET',
        });

        if (error) {
          console.error('Geo check error:', error);
          setIsBlocked(false);
        } else {
          setIsBlocked(!data.allowed);
          setCountry(data.country);
          console.log('Geo check result:', data);
        }
      } catch (error) {
        console.error('Failed to check geo access:', error);
        setIsBlocked(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkGeoAccess();
  }, []);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (isBlocked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="max-w-md text-center space-y-6">
          <div className="space-y-2">
            <h1 className="text-4xl font-bold text-foreground">Service Unavailable</h1>
            <p className="text-lg text-muted-foreground">
              This service is currently only available in the United States and Mexico.
            </p>
          </div>
          {country && country !== 'UNKNOWN' && (
            <p className="text-sm text-muted-foreground">
              Your location: {country}
            </p>
          )}
          <div className="pt-4 text-sm text-muted-foreground">
            If you believe this is an error, please contact support.
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
